import { Component, OnInit } from '@angular/core';
import { SendEmailVerificationBindingModel, IsValidEmailVerificationKeyBindingModel } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';

@Component({
  selector: 'app-update-email-address',
  templateUrl: './update-email-address.component.html',
  styleUrls: ['./update-email-address.component.scss']
})
export class UpdateEmailAddressComponent extends BaseComponent implements OnInit {

  currentEmailVerificationCode: string;

  ngOnInit() {
    this.app.pageTitle = 'Update your email address';
    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.hide();
      this.scrollTo();
    });

    this.start();
  }

  resend() {
    this.app.spinner.show();
    const m = new SendEmailVerificationBindingModel();
    m.email = this.app.customer.email;
    this.app.webBookingService.SendUpdateEmailVerification(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.showInfoMessage('Please check your email to get your email verification code');
        },
        error => {
          this.showErrorMessage(error);
        });
  }

  backToProfile() {
    this.app.router.navigate([AppConstants.RouteProfile]);
  }

  submit() {
    this.app.spinner.show();
    const m = new IsValidEmailVerificationKeyBindingModel();
    m.emailVerificationKey = this.currentEmailVerificationCode;
    m.customerId = this.app.customer.customerId;
    this.app.webBookingService.VerifyCustomerEmail(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.getProfile();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
          this.app.router.navigate([AppConstants.RouteLogin]);
        });
  }

  
  getProfile(): void {
    this.app.webBookingService.GetProfile()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.customer = data;
          this.app.storageService.setItem(AppConstants.Customer, JSON.stringify(this.app.customer));
          this.app.router.navigate([AppConstants.RouteProfile]);
          this.showSuccessMessage('Email successfully verify.');
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

}
